import LazyLoad from '../../../js/lazy-load';

export default new class ProductsSample {
  constructor() {
    this.btnShowmore = '_products-sample-showmore';
    this.ajaxWrapperSelector = 'product-list-module';

    this.tabBtnSelector = 'products-sample__tab';
    this.tabActiveBtnSelector = 'products-sample__tab_active';
    this.idSelector = 'data-id';

    this.preLoaderSelector = 'two-level-slider__preloader';

    this.handler();
    this.changeTab();
  }

  handler() {
    $(document).on('click', `.${this.btnShowmore}`, (e) => {
      const obButton = $(e.currentTarget);

      const id = obButton.attr('data-id');
      const type = obButton.attr('data-type');
      const page = obButton.attr('data-page');
      const object = obButton.attr('data-object');

      const obContainer = obButton.closest('section').find(`.${this.ajaxWrapperSelector}`);

      $.request('ProductsSample::onAjaxRequest', {
        data: {
          id, object, type, page,
        },
        success: function (response) { // eslint-disable-line object-shorthand, func-names
          obContainer.append(response.list).promise().done(() => {
            obButton.parent().html(response.showmore);
            LazyLoad.update();
          });
        },
        // loading: `.${this.preLoaderSelector}`,
      });
    });
  }

  changeTab() {
    const btn = document.querySelectorAll(`.${this.tabBtnSelector}`);

    if (!btn) return;

    [...btn].forEach(el => el.addEventListener('click', () => {
      this.sliderTabHandler(el);
    }));
  }

  sliderTabHandler(el) {
    if (el.matches(`.${this.tabActiveBtnSelector}`)) return;

    const $this = this;
    const id = el.getAttribute(this.idSelector);
    const obSection = $(el).closest('section');

    const obContainer = obSection.find(`.${this.ajaxWrapperSelector}`);

    if (!id) return;

    $.request('ProductsSample::onAjaxRequest', {
      data: {
        id, object: 'obCategory',
      },
      success: function (response) { // eslint-disable-line object-shorthand, func-names
        obContainer.html(response.list).promise().done(() => {
          obSection.find('.showmore__container').html(response.showmore);
          LazyLoad.update();
        });
      },
      loading: `.${this.preLoaderSelector}`,
    });

    $this.changeActiveTab(el);
  }

  changeActiveTab(node) {
    const btn = document.querySelectorAll(`.${this.tabBtnSelector}`);

    [...btn].forEach(el => el.classList.remove(this.tabActiveBtnSelector));

    node.classList.add(this.tabActiveBtnSelector);
  }
}();
